/* Mapping props to a function instead of the actual state helps ensure the data stays up to date. */
import {INITIAL_FILTER} from "./reducers";

function refreshList(state) {
	if(state.list){
		return state.list
	}
	return []
}

function refreshPending(state) {
	if(state.pinned){
		return state.pinned
	}
	return []
}

function refreshHistory(state) {
	if(state.history){
		return state.history
	}
	return []
}

function isLoading(state) {
	// if(state.loading){
		return state.loading
	// }
}

function refreshPostWithId(state, id){
	if(state.details){
		return state.details[id]
	}
	return null
}

function refreshMissedFilter(state){
	if(state.missedFilters){
		return state.missedFilters
	}
	return null
}

function refreshPendingFilter(state){
	if(state.pendingFilters){
		return state.pendingFilters
	}
	return null
}

function refreshFilters(state){

	if(state.pendingMobileFilters){
		const result = {
			0: state.pendingMobileFilters,
			1: state.leavingMobileFilters,
			2: state.returningMobileFilters
		}
		return result
	}
	return INITIAL_FILTER
}

export default {
	isLoading,
	refreshList,
	refreshPending,
	refreshHistory,
	refreshPostWithId,
	refreshMissedFilter,
	refreshPendingFilter,
	refreshFilters
};
